import {
  PayAmountTypography,
  PayAmountContainer,
  AmountContainer,
  PayAmountDiscountTypography,
  SkeletonTotalPriceText,
  PaymentTotalBannerMain,
} from '../styles/PaymentTotalBanner.styles';
import { useOrderAndPaymentInfo } from '../zustand/paymentMethodStore';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';

interface PaymentTotalBannerProps {
  payAmount: number;
  userHasInsurances: boolean;
  quoteLoading: boolean;
}

export const PaymentTotalBanner = ({
  payAmount,
  quoteLoading,
}: PaymentTotalBannerProps) => {
  const { ordersTotal: originalAmount } = useOrderAndPaymentInfo();

  const currencyFormatter = new CurrencyFormatter({
    fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
  });

  return (
    <PaymentTotalBannerMain>
      <PayAmountContainer>
        <PayAmountTypography>Total a pagar:</PayAmountTypography>
        <AmountContainer>
          {originalAmount != payAmount && (
            <PayAmountDiscountTypography>
              {currencyFormatter.format(originalAmount)}
            </PayAmountDiscountTypography>
          )}
          {quoteLoading ? (
            <SkeletonTotalPriceText />
          ) : (
            <PayAmountTypography>
              {payAmount == 0 ? '$0' : currencyFormatter.format(payAmount)}
            </PayAmountTypography>
          )}
        </AmountContainer>
      </PayAmountContainer>
    </PaymentTotalBannerMain>
  );
};
